import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';
import { AppDispatch, RootState } from '../../../../redux/store';
// import {
//   hideLoader,
//   showLoader,
//   setSignUpStep,
// } from '../../../../redux/slices/appSlice';
import {
  checkExistUser,
  setEmail,
  setPassword,
  setResponseMessage,
} from '../../../../redux/slices/authSlice';
import CustomInput from '../../../../components/shared/CustomInput/CustomInput';
import MainButton from '../../../../components/shared/Buttons/MainButton/MainButton';
import ShowPassword from '../../../../components/shared/CustomInput/ShowPassword/ShowPassword';
import './SignUpForm.scss';
import { Link } from 'react-router-dom';

type Props = {
  setStep?: (step: number) => void;
};

export const SignUpForm: React.FC<Props> = ({ setStep = () => {} }) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch<AppDispatch>();
  const lan = localStorage.getItem('lang') || 'en';

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    formState: { errors, isValid, touchedFields },
  } = useForm({ mode: 'all' });

  const { responseMessage } = useSelector((state: RootState) => state.auth);

  const [registerEmail, setRegisterEmail] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const [confirmRegisterPassword, setConfirmRegisterPassword] = useState('');

  // show password
  const [isVisiblePassword, setVisibilityPassword] = useState(false);
  const [isVisibleConfirmPassword, setVisibilityConfirmPassword] =
    useState(false);

  const dataToSend = {
    email: registerEmail,
  };

  useEffect(() => {
    if (responseMessage) {
      toast.error(responseMessage);
      reset();
      setRegisterEmail('');
      setRegisterPassword('');
      setConfirmRegisterPassword('');
      dispatch(setResponseMessage(''));
    }
  }, [responseMessage]);

  // onHandleSubmit
  const onHandleSubmit = () => {
    dispatch(checkExistUser(dataToSend));
    dispatch(setEmail(registerEmail));
    dispatch(setPassword(registerPassword));
    return;
  };

  return (
    <form className="authForm" onSubmit={handleSubmit(onHandleSubmit)}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="createAccountWrapper">
          <span className="createAccount">
            {formatMessage({ id: 'createAccountIn' })}
          </span>{' '}
          <span className="wizwork">
            <b>WizWork</b>
          </span>
        </div>
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <span>{formatMessage({ id: 'alreadyHaveAccount' })}</span>{' '}
          <b>
            <Link to="/sign-in">{formatMessage({ id: 'login' })}</Link>
          </b>
        </div>
        <div style={{ marginTop: 16 }}>
          <CustomInput
            placeholder={formatMessage({ id: 'emailPlaceholder' })}
            label={formatMessage({ id: 'emailLabel' })}
            inputName="email"
            errors={errors}
            touchedFields={touchedFields}
            onChangeFunc={value => {
              setRegisterEmail(value);
              setValue('email', value);
            }}
            width="100%"
            inputProps={{
              ...register('email', {
                required: formatMessage({ id: 'fieldIsEmpty' }),
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message:
                    responseMessage === ''
                      ? formatMessage({ id: 'incorrectEmail' })
                      : formatMessage({ id: 'emailAlreadyRegistered' }),
                },
              }),
              style: {
                fontFamily: lan === 'ar' || lan === 'hi' ? 'Hind' : 'Open Sans',
                textAlign: lan === 'ar' ? 'right' : 'left',
              },
            }}
          />
        </div>
        <div style={{ marginTop: 16 }}>
          <CustomInput
            placeholder={formatMessage({ id: 'passwordPlaceholder' })}
            label={formatMessage({ id: 'passwordLabel' })}
            inputName="password"
            errors={errors}
            touchedFields={touchedFields}
            onChangeFunc={(value: string) => {
              setRegisterPassword(value);
              setValue('password', value);
            }}
            inputProps={{
              ...register('password', {
                required: formatMessage({ id: 'fieldIsEmpty' }),
                minLength: {
                  value: 8,
                  message: formatMessage({ id: 'weakPassword' }),
                },
                pattern: {
                  value:
                    // from memoria
                    // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*():;,\-_=+`~\[\]{}?|]).{8,20}.[^<>]+$/,
                    // from growthInsight
                    // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,255}$/,
                    // from alex pryz
                    /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~!@#$%^&*()_\-\+={}\[\]'";:?.>\|,<\\])[A-Za-z\d`~!@#$%^&*()_\-\+={}\[\]'";:?.>\|,<\\]{8,}/i,
                  message: formatMessage({ id: 'weakPassword' }),
                },
              }),
              // passwords to check out
              // *IK<mju7
              // (OL>,ki8
              // &UJM,ki8
              type: isVisiblePassword ? 'text' : 'password',
              style: {
                fontFamily: lan === 'ar' || lan === 'hi' ? 'Hind' : 'Open Sans',
                textAlign: lan === 'ar' ? 'right' : 'left',
              },
            }}
            InputProps={{
              endAdornment: (
                <ShowPassword
                  onClick={() => {
                    setVisibilityPassword(!isVisiblePassword);
                  }}
                  isVisible={isVisiblePassword}
                />
              ),
              style: {
                fontFamily: lan === 'ar' || lan === 'hi' ? 'Hind' : 'Open Sans',
                textAlign: lan === 'ar' ? 'right' : 'left',
              },
            }}
          />
        </div>
        <div style={{ marginTop: 16, marginBottom: 24 }}>
          <CustomInput
            placeholder={formatMessage({ id: 'passwordPlaceholder' })}
            label={formatMessage({ id: 'confirmPasswordLabel' })}
            inputName="confirmPassword"
            errors={errors}
            touchedFields={touchedFields}
            onChangeFunc={(value: string) => {
              setConfirmRegisterPassword(value);
              setValue('confirmPassword', value);
            }}
            inputProps={{
              ...register('confirmPassword', {
                required: formatMessage({ id: 'fieldIsEmpty' }),
                validate: value =>
                  value === getValues('password') ||
                  formatMessage({ id: 'unmatchingPassword' }),
              }),
              type: isVisibleConfirmPassword ? 'text' : 'password',
              style: {
                fontFamily: lan === 'ar' || lan === 'hi' ? 'Hind' : 'Open Sans',
                textAlign: lan === 'ar' ? 'right' : 'left',
              },
            }}
            InputProps={{
              endAdornment: (
                <ShowPassword
                  onClick={() => {
                    setVisibilityConfirmPassword(!isVisibleConfirmPassword);
                  }}
                  isVisible={isVisibleConfirmPassword}
                />
              ),
              style: {
                fontFamily: lan === 'ar' || lan === 'hi' ? 'Hind' : 'Open Sans',
                textAlign: lan === 'ar' ? 'right' : 'left',
              },
            }}
          />
        </div>
        <MainButton
          text={formatMessage({ id: 'createAccount' })}
          type="submit"
          disabled={!isValid}
        />
      </div>
    </form>
  );
};

export default SignUpForm;
